/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing WAF related components and services.
 * @preferred
 * @module WafModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VIPModule } from '@vmw/ngx-vip';
import { AviCardModule } from 'nsx-alb-ui-components';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { MatchModule } from 'ng/modules/match/match.module';
import { ClrSpinnerModule } from '@clr/angular';
import { DialogModule } from 'ng/modules/dialog/dialog.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';

import {
    WafAddExceptionDialogComponent,
    WafApplicationRulesListComponent,
    WafApplicationRulesListHeaderComponent,
    WafPolicyCloneDialogComponent,
    WafPolicyListPageComponent,
    WafProfileListComponent,
    WafUserOverridesBadgeComponent,
} from './components';

import {
    WafAddExceptionDialogFormDirective,
} from './directives';

import {
    wafApplicationSignatureProviderCollectionProvider,
    wafApplicationSignatureProviderProvider,
} from '../../ajs-upgraded-providers';

import {
    latestWafCrsVersionServiceProvider,
    wafPolicyCloneableItemProvider,
    wafPolicyCollectionProvider,
    wafPolicyItemProvider,
    wafProfileCollectionProvider,
} from './ajs-upgraded-providers';

const wafComponents = [
    WafAddExceptionDialogComponent,
    WafApplicationRulesListComponent,
    WafApplicationRulesListHeaderComponent,
    WafProfileListComponent,
    WafPolicyCloneDialogComponent,
    WafPolicyListPageComponent,
    WafUserOverridesBadgeComponent,
];

const wafDirectives = [
    WafAddExceptionDialogFormDirective,
];

@NgModule({
    declarations: [
        ...wafComponents,
        ...wafDirectives,
    ],
    exports: [
        WafUserOverridesBadgeComponent,
    ],
    imports: [
        AviCardModule,
        ClrSpinnerModule,
        CommonModule,
        DragDropModule,
        SharedModule,
        DialogModule,
        AviFormsModule,
        MatchModule,
        VIPModule,
        DataGridModule,
    ],
    providers: [
        latestWafCrsVersionServiceProvider,
        wafApplicationSignatureProviderProvider,
        wafApplicationSignatureProviderCollectionProvider,
        wafPolicyCollectionProvider,
        wafProfileCollectionProvider,
        wafPolicyItemProvider,
        wafPolicyCloneableItemProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class WafModule { }
